<!--
    Generic bubble component displayed inside a map.

    <SimpleBubble
        height="..."   # Optional - if any height applied on bubble
        width="..."    # Optional - if any width applied on bubble
    >
      # Slot which will container the tooltip container
    </SimpleBubble>
 -->
<script setup lang="ts">
type Props = {
  size?: 'xs' | 's' | 'm';
};

const props = withDefaults(defineProps<Props>(), {
  size: 'm'
});

const bubble = {
  xs: 21,
  s: 24,
  m: 26
};
</script>
<template>
  <v-sheet class="bubble d-flex align-center justify-center" :height="bubble[props.size]" :width="bubble[props.size]">
    <slot></slot>
  </v-sheet>
</template>

<style scoped lang="scss">
.bubble {
  border-radius: 50%;
}
</style>
